import {authService} from "@/services/AuthService.class";
import {accountService} from "@/services/AccountService.class";
import {isLoggedIn, loadToken, saveToken, removeToken} from "@/helper/LocalStorageHelper";
import User from "../model/User";


const state = {
  loggedIn: isLoggedIn(),
  token: loadToken(),
  user: null
};
const actions = {
  doLoginAction({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      const loginPromise = authService.doLogin(payload.username, payload.password);
      loginPromise.then((data) => {
        saveToken(data);
        dispatch('getMyAccount').then(accountResponse => {
          if (accountResponse.data.userAuthority !== 'USER') {
            commit('loggedInMutation', {loggedIn: true, token: data});
            resolve(data);
          } else {
            removeToken();
            reject({status: 403, message: 'User is not Admin'});
          }
        });

      }).catch((error) => {
        console.error('AUTH-STORE ERROR', error);
        reject();
      });
      return loginPromise
    })

  },
  doEntraLoginAction({dispatch, commit}, accessToken) {
    return new Promise((resolve, reject) => {
      authService.doEntraLogin(accessToken).then((data) => {
        saveToken(data);
        dispatch('getMyAccount').then(accountResponse => {
          if (accountResponse.data.userAuthority !== 'USER') {
            commit('loggedInMutation', {loggedIn: true, token: data});
            resolve(data);
          } else {
            removeToken();
            reject({status: 403});
          }
        });
      }).catch((error) => {
        console.error('AUTH-STORE ERROR', error);
        reject();
      });
    })

  },
  getMyAccount({commit}) {
    return accountService.getMyAccount().then((response) => {
      commit('setUser', response.data);
      return response;
    })
  },
  logoutAction({commit}) {
    return new Promise((resolve) => {
      removeToken();
      commit('setUser', {});
      commit('loggedInMutation', {loggedIn: false, token: null});
      resolve();
    })

  }
};
const mutations = {
  loggedInMutation(state, payload) {
    state.token = payload;
    state.loggedIn = payload.loggedIn
  },
  setUser(state, payload) {
    state.user = new User(payload);
  }
};
const getters = {
  getUser(state) {
    return state.user;
  },
  isAdmin(state) {
    if (state.user && state.user.userAuthority) {
      return state.user.userAuthority.toLowerCase() === 'admin';
    }
    return false;
  },
  isReporter(state) {
    if (state.user && state.user.userAuthority) {
      return state.user.userAuthority.toLowerCase() === 'reporter';
    }
    return false;
  },
  isSuperAdmin(state) {
    if (state.user && state.user.userAuthority) {
      return state.user.userAuthority.toLowerCase() === 'super_admin';
    }
    return false;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}
